import { render, staticRenderFns } from "./ResourcesMedia.vue?vue&type=template&id=f04f7e26&scoped=true"
import script from "./ResourcesMedia.vue?vue&type=script&lang=ts"
export * from "./ResourcesMedia.vue?vue&type=script&lang=ts"
import style0 from "./ResourcesMedia.vue?vue&type=style&index=0&id=f04f7e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04f7e26",
  null
  
)

export default component.exports